import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { saveRecaptchaPassed } from '../utils/storage';


const CaptchaContainer = ({ setIsCaptchaVerified }) => {
    const handleRecaptchaChange = (value) => {
        if (value) {
            setIsCaptchaVerified(true);
            saveRecaptchaPassed(true);
        }
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h2>Please verify that you are human</h2>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                    onChange={handleRecaptchaChange}
                />
                <br />
            </div>
        </div>
    );
};

export default CaptchaContainer;
